import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../AuthContext';
import './Daily.css'; // Reutilizamos estilos
import slide1 from '../assets/fact1.avif';
import slide2 from '../assets/fact2.avif';
import slide3 from '../assets/NotasC.avif';
import slide4 from '../assets/PanelNC.avif';

import { BarChart3, Notebook,  } from 'lucide-react';

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

const Facturación = () => {
  const navigate = useNavigate();
  const { session } = useAuth();

  const allowedRolesForKPI = [
    'Gerente de Administración de Ventas',
    'Coordinador de Inteligencia de Negocio',
    'Coordinadora de Administración de Ventas'
  ];

  const canSeeKPIs = allowedRolesForKPI.includes(session?.user?.cargo);

  return (
    <motion.div 
      className="dashboard-container"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={isMobile ? { duration: 0.25 } : { duration: 0.5 }}
    >
      <div className="title-section">
        <h1 className="dailymenu">Administración de Ventas</h1>
        <div className="title-underline-daily"></div>
        <h1 className="subtitle-daily">Facturación</h1>
      </div>

      <div className="daily-menu-grid">
          {/* Card 1: KPIs Facturación */}
          {canSeeKPIs && (
          <div className="daily-card" onClick={() => navigate('/kpi-fact')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide1})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <BarChart3 size={28} color="white" />
              </div>
              <h3>Kpis Facturación</h3>
              <p>Análisis de de facturación y promedios de ventas.</p>
            </div>
          </div>
          )}

          {/* Card 2: Detalle Facturación */}
          <div className="daily-card" onClick={() => navigate('/detalle-fact')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide2})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <Notebook size={28} color="white" />
              </div>
              <h3>Detalle Facturación</h3>
              <p>Detalle de Facturas realizadas.</p>
            </div>
          </div>
           {/* Card 3: Notas de Crédito*/}
          
          <div className="daily-card" onClick={() => navigate('/detalle-notascredito')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide3})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <Notebook size={28} color="white" />
              </div>
              <h3>Notas de Crédito</h3>
              <p>Detalle de Notas de Crédito emitidas.</p>
            </div>
          </div>

          {/* Card 4: Panel Notas de Crédito*/}
          
          <div className="daily-card" onClick={() => navigate('/panel-notascredito')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide4})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <Notebook size={28} color="white" />
              </div>
              <h3>Analisis Notas de Crédito</h3>
              <p>Analisis y Kpis de Notas de Crédito emitidas.</p>
            </div>
          </div>
      </div>
    </motion.div>
  );
};

export default Facturación;